import React from 'react';

const AboutUs = () => {
    return (
        <div className="about-us-section">
            <div className="about-us-container">
                <h2 className="about-us-title">About Us</h2>
                <p className="about-us-description">
                    Explore online career counselling services to help you discover your dream career. Receive personalized career advice and expert’s mentorship to make informed decisions and achieve professional success from the comfort of your home.
                </p>
                <p className="about-us-description">
                    Built on the foundation of the innovative “Align with Expertise” model, this approach combines a self-paced methodology with personalized guidance to uncover and nurture each individual’s unique potential. Whether it begins with a hobby, a passion, or an untapped skill, The Ideal Pursuits provides the tools and mentorship needed to transform these elements into a meaningful and rewarding career.
                </p>
                <p className="about-us-description">
                    By connecting participants with experienced career coaches and industry experts, The Ideal Pursuits ensures access to tailored advice, actionable insights, and real-world strategies. The “Align with Expertise” framework makes the journey intuitive and effective, offering a clear path for individuals to achieve their aspirations while fostering personal and professional growth.
                </p>
                <p className="about-us-description">
                    With a focus on creating value for individuals seeking clarity and direction in their career journeys, The Ideal Pursuits aims to inspire a generation of professionals to pursue paths that align with their passions and purpose, making it achievable to fulfill their aspirations with ease.
                </p>

                <div className="service-container">
                    <div className="service-card">
                        <h3 className="service-title">Self-Paced Learning</h3>
                        <p className="service-description">
                            Learn at your own pace with curated tests that match your skill level. Our platform offers flexibility, allowing you to absorb knowledge at your convenience and progress when you're ready.
                        </p>
                    </div>
                    <div className="service-card">
                        <h3 className="service-title">Career Coaches</h3>
                        <p className="service-description">
                            Our expert career coaches provide personalized support, guidance, and mentorship. They’ll help you define your career path, overcome obstacles, and offer actionable advice on your professional journey.
                        </p>
                    </div>
                    <div className="service-card">
                        <h3 className="service-title">Industrial Experts</h3>
                        <p className="service-description">
                            Learn from industry leaders and professionals who have real-world experience. Their insights give you a competitive edge, ensuring that you are equipped with the skills needed in today’s fast-paced job market.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;
